export default __webpack_public_path__ + "static/media/054.084d7ce9.jpg";